export default __webpack_public_path__ + "images/EW.cf19365.png";